export const API_URL = 'https://api.themoviedb.org/3/';
export const API_KEY = 'f36f23edf6e10fd2ddcf939916b1f67a';